module.exports = __webpack_public_path__ + "img/elegant-scheme.e490b00a.png";